import Field, { describedBy } from "@/components/Field";
import PasswordInput from "@/components/PasswordInput";

export const MIN_PASSWORD_LENGTH = 10;

export interface NewPassword {
  password: string;
  confirm: string;
}

export const EMPTY_NEW_PASSWORD: NewPassword = { password: "", confirm: "" };

export const newPasswordErrors = ({ password, confirm }: NewPassword) => ({
  password: !password
    ? "Kies een wachtwoord"
    : password.length < MIN_PASSWORD_LENGTH
      ? `Gebruik minstens ${MIN_PASSWORD_LENGTH} tekens`
      : null,
  confirm: !confirm
    ? "Herhaal het wachtwoord"
    : confirm !== password
      ? "De wachtwoorden komen niet overeen"
      : null,
});

export const isValidNewPassword = (value: NewPassword) => {
  const errors = newPasswordErrors(value);
  return errors.password == null && errors.confirm == null;
};

interface Props {
  value: NewPassword;
  onChange(value: NewPassword): void;
  // Validation messages appear once the form has been submitted.
  showErrors: boolean;
}

const NewPasswordFields: React.FC<Props> = ({ value, onChange, showErrors }) => {
  const errors = showErrors ? newPasswordErrors(value) : { password: null, confirm: null };
  return (
    <>
      <Field
        id="new-password"
        label="Nieuw wachtwoord"
        error={errors.password}
        hint={`Minstens ${MIN_PASSWORD_LENGTH} tekens.`}
      >
        <PasswordInput
          id="new-password"
          autoComplete="new-password"
          value={value.password}
          aria-invalid={errors.password != null}
          aria-describedby={describedBy("new-password")}
          onChange={(e) => onChange({ ...value, password: e.target.value })}
        />
      </Field>
      <Field id="confirm-password" label="Herhaal wachtwoord" error={errors.confirm}>
        <PasswordInput
          id="confirm-password"
          autoComplete="new-password"
          value={value.confirm}
          aria-invalid={errors.confirm != null}
          aria-describedby={describedBy("confirm-password")}
          onChange={(e) => onChange({ ...value, confirm: e.target.value })}
        />
      </Field>
    </>
  );
};

export default NewPasswordFields;
